import { Yield } from '../../abacus/interfaces/yield.interface'

export const targetGroupYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
